// src/plugins/vuetify.js
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default createVuetify({
  defaults: {
    VDataTable: {
      density: 'compact',
    },
  },
  theme: {
    defaultTheme: 'japonClassique',
    themes: {
      japonClassique: {
        dark: false,
        colors: {
          // 🎋 Théme inspiré du Japon classique : papier, bois sombre et ambre
          primary: '#7A4B3A',
          'primary-darken-1': '#5A2F24',
          'primary-lighten-1': '#D9C0A6',
          accent: '#C97C4A',
          secondary: '#8B6A3F',
          background: '#F8F2E8',
          surface: '#FFFDF8',
          'on-primary': '#FFF8F2',
          'on-background': '#2F241C',
          'on-surface': '#2F241C',
          divider: '#E7DCCB',
          statsHeader: '#EEE1CF',
          onStatsHeader: '#5A3A2B',
          statsAccent: '#A96A3A',
          statsRowAlt: '#F7EFE2',
          statsRowHover: '#EEDFCB',
          statsRowSelected: '#E4D0B4',
          surfaceMuted: '#F3EBDD',
          borderSoft: '#D8C2A3',
        },
      },
      japonClassiqueDark: {
        dark: true,
        colors: {
          // 🌙 Variante sombre avec teintes d’encre et de bois noirci
          primary: '#A46B4B',
          'primary-darken-1': '#7D4B31',
          'primary-lighten-1': '#D5B28D',
          accent: '#C78849',
          secondary: '#8A7A4D',
          background: '#16110E',
          surface: '#241A16',
          'on-primary': '#FFF4EA',
          'on-background': '#F2E7D7',
          'on-surface': '#F2E7D7',
          divider: '#4A3C33',
          statsHeader: '#2C1E18',
          onStatsHeader: '#E7D5B4',
          statsAccent: '#A46B4B',
          statsRowAlt: '#1F1712',
          statsRowHover: '#2E211B',
          statsRowSelected: '#3A2A20',
          surfaceMuted: '#1C1612',
          borderSoft: '#4B3B2E',
        },
      },
      light: {
        dark: false,
        colors: {
          primary: '#7A4B3A',
          'primary-darken-1': '#5A2F24',
          'primary-lighten-1': '#D9C0A6',
          accent: '#C97C4A',
          secondary: '#8B6A3F',
          background: '#F8F2E8',
          surface: '#FFFDF8',
          'on-primary': '#FFF8F2',
          'on-background': '#2F241C',
          'on-surface': '#2F241C',
          divider: '#E7DCCB',
          statsHeader: '#EEE1CF',
          onStatsHeader: '#5A3A2B',
          statsAccent: '#A96A3A',
          statsRowAlt: '#F7EFE2',
          statsRowHover: '#EEDFCB',
          statsRowSelected: '#E4D0B4',
          surfaceMuted: '#F3EBDD',
          borderSoft: '#D8C2A3',
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: '#A46B4B',
          'primary-darken-1': '#7D4B31',
          'primary-lighten-1': '#D5B28D',
          accent: '#C78849',
          secondary: '#8A7A4D',
          background: '#16110E',
          surface: '#241A16',
          'on-primary': '#FFF4EA',
          'on-background': '#F2E7D7',
          'on-surface': '#F2E7D7',
          divider: '#4A3C33',
          statsHeader: '#2C1E18',
          onStatsHeader: '#E7D5B4',
          statsAccent: '#A46B4B',
          statsRowAlt: '#1F1712',
          statsRowHover: '#2E211B',
          statsRowSelected: '#3A2A20',
          surfaceMuted: '#1C1612',
          borderSoft: '#4B3B2E',
        },
      },
    },
  },
})
